<template>
  <div style="width:100vw;">
    <div id="headerbar">
      <div class="logo" @click="goHome">
        <img src="../../assets/images/logo_white.png" />
      </div>
      <div class="button-group" style="flex:auto;">
        <div class="btn-group">
          <div class="el-btn el-btn-control">
            <button @click="saveTemplate(false)">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#icon-save"></use>
              </svg>
            </button>
            <p>保存</p>
          </div>
          <div class="el-btn el-btn-control">
            <button @click="saveTemplate(true)">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#icon-saveas"></use>
              </svg>
            </button>
            <p>另存为</p>
          </div>
          <div class="el-btn el-btn-control">
            <button @click="previewVideo">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#icon-preview"></use>
              </svg>
            </button>
            <p>预览</p>
          </div>
          <div class="el-btn el-btn-control">
            <button @click="goHome">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#icon-return"></use>
              </svg>
            </button>
            <p>返回</p>
          </div>
        </div>
      </div>
      <div style="width:256px;"></div>
    </div>
    <div id="stage">
      <div class="inner">
        <div id="canvas" ref="canvas" @mousedown.stop="cancelSelect">
          <div
            id="page"
            :style="pageStyle"
            @contextmenu.prevent="$refs.menu.open"
          >
            <video id="video" :src="videoUrl" controls></video>
          </div>
        </div>
        <div id="attribute-panel" style="width:350px;">
          <div class="ae-content">
            <div class="title">视频模板编辑</div>
            <div class="cl-container" style="padding:16px 12px;">
              <div class="field" v-for="item in elements" :key="item.name">
                <text-field v-if="item.type === '.text'" :data="item" />
                <video-field v-else-if="type === '.mp4'" :data="item" />
                <image-field v-else :data="item" />
              </div>
              <p class="form-field time">
                <label>定帧图</label>
                <!-- <span class="slice">截取第</span> -->
                <!-- <el-input min="0" type="number" size="mini" :value="snapshotTime" @change="updateAttr"/>  -->
                <!-- <label>秒</label> -->
                <el-input size="mini" :value="snapshotTime" @input="updateAttr">
                  <template slot="prepend">截取第</template>
                  <template slot="append">秒</template>
                </el-input>
              </p>
              <div class="field">
                <upload-audio
                  :value="music"
                  label="背景音乐"
                  @input="updateMusic($event)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog class="preview-dialog" title="预览" :visible.sync="preview">
      <video class="video" v-if="url" :src="url" controls />
    </el-dialog>
    <el-dialog title="保存" :visible.sync="dialogVisible" width="60%">
      <div class="form">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="100px"
          label-position="left"
        >
          <el-form-item label="保存为">
            <el-radio-group v-model="form.design_type" size="lage">
              <el-tooltip
                class="item"
                effect="dark"
                placement="right"
                v-for="item in designTypeOptions"
                :key="item.value"
                :disabled="item.value !== 0"
              >
                <div slot="content">
                  1.模板是指带有可替换标记的图片或/视频<br />2.利用模板可批量生成创意或者程序化投放中实时生成创意
                </div>
                <el-radio-button :label="item.value" :value="item.value">
                  {{ item.name }}
                </el-radio-button>
              </el-tooltip>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="名称" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveTemplateHandler">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import VideoAttributeContent from 'components/VideoAttributeContent';
import ResourcePanel from 'components/ResourcePanel';
import VideoElementEditor from 'components/editor/VideoElementEditor';
import Timeline from 'components/editor/Timeline';
import ResourceList from 'components/editor/ResourceList';
import { Message } from 'element-ui';

import AETextField from 'components/field/AETextField';
import AEVideoField from 'components/field/AEVideoField';
import AEImageField from 'components/field/AEImageField';

import _ from 'lodash';
import drag from 'mixins/drag';
import UploadImage from 'components/UploadImage';
import ConfigPanel from 'components/ConfigPanel';
import Axios from 'utils/axios';
import Mousetrap from 'mousetrap';
import { DESIGN_TYPE_OPTIONS } from 'constant/design';

export default {
  mixins: [drag],
  data() {
    return {
      form: {
        source: 0,
        resizeType: 1,
        groupId: null,
        groupName: '',
        name: '',
        design_type: 1,
        defaultPath: {}
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        defaultPath: [{ required: true, message: '请上传容错图' }]
      },
      type: 0,
      designTypeOptions: DESIGN_TYPE_OPTIONS,
      saveNew: false,
      dialogVisible: false,
      change: false,
      isDragging: false,
      container: null,
      interval: null,
      activeMenuIndex: null,
      position: null,
      url: '',
      preview: false,
      scrollTop: 0
      // snapshotTime: 0
    };
  },
  components: {
    UploadImage,
    ConfigPanel,
    Timeline,
    ResourceList,
    'video-field': AEVideoField,
    'text-field': AETextField,
    'image-field': AEImageField,
    'editor-element': VideoElementEditor,
    'attribute-panel': VideoAttributeContent,
    'resource-panel': ResourcePanel
  },
  watch: {},
  computed: {
    elements() {
      return this.$store.state.elements || [];
    },
    music() {
      return this.$store.state.ae_tpl.bgmusic;
    },
    snapshotTime() {
      return this.$store.state.ae_tpl.snapshotTime;
    },
    video() {
      return this.$store.state.task_api_response;
    },
    videoUrl() {
      let response = {};
      try {
        response = JSON.parse(this.video).data;
      } catch (e) {
        response = {};
      }
      return response.outputurl;
    },
    designWidth() {
      return this.$store.state.designWidth;
    },
    designHeight() {
      return this.$store.state.designHeight;
    },
    scaleRate() {
      return this.$store.state.scaleRate;
    },
    canvas() {
      return this.$store.state.canvas || [];
    },
    keys() {
      return this.$store.state.keys || [];
    },
    template() {
      return this.$store.state.tpl;
    },
    activeKey() {
      return this.$store.state.activeKey;
    },
    canvasWidth() {
      return this.designWidth * this.scaleRate;
    },
    canvasHeight() {
      return this.designHeight * this.scaleRate;
    },
    output() {
      return this.$store.state.outputDesc || {};
    },
    pageStyle() {
      return {
        width: this.canvasWidth + 'px',
        height: this.canvasHeight + 'px',
        backgroundColor: this.output.bgColor
      };
    },
    selected() {
      return this.$store.state.selected;
    },
    list() {
      return this.$store.state.basic.list || [];
    },
    total() {
      return this.$store.state.basic.total;
    },
    limit() {
      return this.$store.state.basic.pageSize;
    },
    group() {
      return this.$store.state.group.list || [];
    }
  },
  beforeDestroy() {
    this.$store.commit('update', {
      designWidth: 0,
      designHeight: 0,
      scaleRate: 1,
      keys: [],
      canvas: []
    });
  },
  mounted() {
    if (this.$route.params.id) {
      this.fetchTemplate();
    } else if (this.$route.query.tpl) {
      Axios.get('/admin/videoTemplate/detail', {
        params: {
          id: this.$route.query.tpl
        }
      }).then(res => {
        this.$store.commit('load_video', res);
      });
    }
    this.container = this.$refs.canvas;
  },
  methods: {
    fetchTemplate() {
      this.$store
        .dispatch('video/fetchOne', {
          id: +this.$route.params.id
        })
        .then(res => {
          this.$store.commit('load_video', res);
        });
    },
    goHome() {
      this.$router.push('/video/template');
    },
    cancelSelect() {
      // this.$store.dispatch('elm_unselect')
    },
    addText() {
      this.$store.dispatch('elm_add', {
        type: 'text',
        width: 100,
        height: 50,
        x: this.canvasWidth / 2,
        y: this.canvasHeight / 2,
        content: '双击编辑文字',
        isDynamic: 0,
        isCover: 0,
        style: {
          fontSize: 20
        }
      });
    },
    addImage() {
      this.$store.dispatch('elm_add', {
        type: 'image',
        width: 200,
        height: 200,
        isDynamic: 0,
        isCover: 0,
        x: this.canvasWidth / 2,
        y: this.canvasHeight / 2,
        content: ''
      });
    },
    undoAction() {
      this.$store.commit('undo_history');
    },
    redoAction() {
      this.$store.commit('redo_history');
    },
    removeItem() {
      this.$store.commit('elm_remove', { id: this.selected.id });
    },
    updateMusic(url) {
      this.$store.commit('update_ae_music', { url });
    },
    updateAttr(time) {
      // console.log(time)
      this.$store.commit('update_ae_time', { time: Number(time) });
    },
    saveTemplate(n) {
      this.form.name =
        (this.$store.state.video.data && this.$store.state.video.data.name) ||
        '视频';
      this.dialogVisible = true;
      this.form.design_type = 1;
      this.saveNew = n;
    },
    saveTemplateHandler() {
      const loading = this.$loading({
        lock: true,
        text: '正在创建, 请耐心等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$store
        .dispatch('video/saveAE', {
          id:
            this.saveNew || !this.$route.params.id
              ? null
              : +this.$route.params.id,
          name: this.form.name,
          design_type: this.form.design_type
        })
        .then(res => {
          loading.close();
          this.$router.replace('/ae/edit/' + res.id);
          this.dialogVisible = false;
          this.$message.success('保存成功');
          this.$store.commit('load_video', res);
        })
        .catch(res => {
          loading.close();
          this.dialogVisible = false;
        });
    },
    previewVideo() {
      const loading = this.$loading({
        lock: true,
        text: '正在创建, 请耐心等待',

        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$store.dispatch('video/previewAE').then(res => {
        loading.close();
        if (typeof res.data === 'string') {
          this.url = res.data;
          this.preview = true;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../../stylesheets/base';

.form-field :global(label) {
  min-width: 65px;
  color: #999;
  font-size: 12px;
}

#video {
  height: 360px;
  width: 690px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #d8d8d8;
}

#stage {
  display: flex;
  flex-direction: column;
  > .inner {
    flex: auto;
    display: flex;
  }
}

#canvas-tab {
  width: 100%;
  height: 40px;
  display: flex;
  background-color: #efefef;
  > .tab {
    flex: 1;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    line-height: 40px;
    border-left: 1px solid #d8d8d8;
    border-bottom: 1px solid #d8d8d8;
    .close {
      cursor: pointer;
    }
    &:first-child {
      border-left: 0;
    }
    &.active {
      background: #f8f8f8;
      border-bottom: 0;
    }
  }
}

.image-list {
  width: 100%;
  overflow: hidden;
  display: flex;
  > * {
    label {
      min-width: 50px;
    }
    margin-right: 20px;
    display: flex;
  }
}

#page {
  background: #ffffff;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.button-group {
  display: flex;
  justify-content: space-around;
}

.btn-group {
  min-width: 130px;
  display: flex;
  justify-content: space-between;
}

.dialog-footer {
  text-align: center !important;
}

.select-mask {
  position: absolute;
  border: 1px dashed $green;
  background-color: rgba(0, 205, 154, 0.3);
}

.toolbar {
  position: absolute;
  top: 170px;
  right: 0;
  z-index: 999;
  > .action-button {
    width: 36px;
    height: 36px;
    padding: 7px;
    box-sizing: border-box;
    margin-bottom: 6px;
    background-color: #4a4a4a;
    border-radius: 6px;
    cursor: pointer;
    &.disabled {
      pointer-events: none;
      opacity: 0.3;
    }
    &:active {
      opacity: 0.8;
    }
    > i {
      color: #fff;
      display: block;
      width: 22px;
      height: 22px;
      font-size: 22px;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.slider {
  left: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #d8d8d8;
  position: absolute;
  .inner {
    margin: 0 auto;
    width: 300px;
    height: 40px;
    display: flex;
    align-items: center;
    > span {
      flex: none;
      margin-left: 20px;
    }
    > :global(.el-slider) {
      width: 200px;
      flex: none;
    }
    :global(.el-slider__bar),
    :global(.el-slider__runway) {
      background: #d8d8d8;
    }
    :global(.el-slider__button) {
      width: 12px;
      height: 12px;
      background: #4a90e2;
      border: 0;
      margin: 5px;
    }
  }
}
.preview-dialog {
  text-align: center;
}
.video {
  height: 400px;
  max-width: 100%;
}
</style>
